import React from 'react';
import {Link} from 'react-router';
import {FormattedMessage} from 'react-intl';
import contactUsUrl from '../../utils/url/contactUsUrl';
import loginUrl from '../../utils/url/loginUrl';
import registerUrl from '../../utils/url/registerUrl';
import forgotPasswordUrl from '../../utils/url/forgotPasswordUrl';
import termsOfUseUrl2 from '../../utils/url/termsOfUseUrl2';
import privacyPolicyUrl2 from "../../utils/url/privacyPolicyUrl2";

export const loginLink = <Link to={loginUrl()}><FormattedMessage id="common.login" /></Link>;
export const resetLink = <Link to={forgotPasswordUrl()}><FormattedMessage id="common.reset" /></Link>;
export const registerTryAgain = <a href={registerUrl()}><FormattedMessage id="common.tryAgain" /></a>;
export const signUp = <a href={registerUrl()}><FormattedMessage id="common.signUp" /></a>;
export const contactUsLink = <a href={contactUsUrl()} target="_blank"><FormattedMessage id="common.link.contactUs.text" /></a>;
export const privacyPolicyLink = <a target="_blank" href={privacyPolicyUrl2()}><FormattedMessage id="registration.signUp.privacyPolicy.text"/></a>;
export const termsOfUseLink = <a target="_blank" href={termsOfUseUrl2()}><FormattedMessage id="registration.signUp.termsOfUse.text"/></a>;
export const termsAndConditionsLink = <a target="_blank" href={termsOfUseUrl2()}><FormattedMessage id="otpType.termsAndConditions.text"/></a>;
export const agreeAndSignUpText = <FormattedMessage id="registration.button.continue" />;
export const confirmForgotPasswordText = <FormattedMessage id="forgotPassword.button.confirm" />;
export const confirmResetPasswordText = <FormattedMessage id="resetPassword.button.confirm" />;



// WEBPACK FOOTER //
// ./src/auth/authWithOtp/staticComponents2.js